import type { FaireProductEntity } from "../../entity_types/product";

export const p_sj98g43pjm: FaireProductEntity = {
  token: "p_sj98g43pjm",
  type: "product",
  name: "Cherry Cola",
  brandToken: "b_2ncsmapy03",
  brandName: "Olipop",
  imageUrl:
    "https://cdn.faire.com/fastly/ee8bf138d42beef3a9d4bbe48041041b8d066b95ec4bf76410ed9164cea9d0cd.png",
  galleryImageUrls: [],
  priceDollars: 28.99,
  description:
    "Imagine your favorite cherry cola. Now imagine it made with real spices, tart cherry juice, and bursting with authentic cola’s crave-worthy collision of sweet and dark flavors. That’s what you’re holding in your hands: a better-for-you remix of a traditionally artificial soda, ready for you to take the first sip.",
  tags: [],
  msrpDollars: 57.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-30T17:24:10.952Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
